import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="w-full px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="text-2xl font-heading font-black text-primary-400">51</span>
              <span className="text-lg font-heading font-bold text-foreground-100">影视</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              51影视网致力于为广大用户提供免费高清流畅的在线观影体验。
              海量影视资源，无需缓冲，随时随地畅享精彩内容。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">
              <a href="#quick-links" className="cursor-pointer">快速链接</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">全部分类</Link>
              </li>
              <li>
                <Link to="/category/热播剧集" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">热播剧集</Link>
              </li>
              <li>
                <Link to="/category/科幻大片" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">科幻大片</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">
              <a href="#support" className="cursor-pointer">帮助支持</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link>
              </li>
              <li>
                <a href="#contact" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">联系我们</a>
              </li>
              <li>
                <a href="#faq" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a>
              </li>
              <li>
                <a href="#feedback" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">用户反馈</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100 mb-4">
              <a href="#contact-info" className="cursor-pointer">联系方式</a>
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line text-base"></i>
                <span>contact@51yingshi.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-phone-line text-base"></i>
                <span>400-888-8888</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-map-pin-line text-base"></i>
                <span>北京市朝阳区影视产业园区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 51影视网 版权所有 | 京ICP备2026000001号
          </p>
          <div className="flex items-center gap-4">
            <a href="#privacy" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#terms" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">服务条款</a>
            <a href="#disclaimer" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}